import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  left: null,
  right: null,
  top: null,
  bottom: null,
};

const mapEdgesSlice = createSlice({
  name: 'mapEdges',
  initialState,
  reducers: {
    setEdges: (state, action) => {
      const { left, right, top, bottom } = action.payload;
      state.left = left;
      state.right = right;
      state.top = top;
      state.bottom = bottom;
    },
  },
});

export const { setEdges } = mapEdgesSlice.actions;
export default mapEdgesSlice.reducer;